export const getDataTokenName = dataTokenValue => {
  return (dataTokenValue === null || dataTokenValue === void 0 ? void 0 : dataTokenValue.split('.')[0]) || '';
};
export const getDataTokenPath = dataTokenValue => {
  return (dataTokenValue === null || dataTokenValue === void 0 ? void 0 : dataTokenValue.split('.').slice(1).join('.')) || '';
};